export default "__VITE_ASSET__184ad0fc__"